import React, { useEffect } from 'react';
import { CustomBackdrop } from '../../components/backdrop';
import { ExalusBackdropPopup } from '../../integrations/exalus/components/exalus-backdrop-popup';
import { enableScroll } from '../../utils/helpers/scroll';
import { hideSplashScreen } from '../../utils/helpers/splashscreen';

export const OverAppLocal: React.FC = () => {
  useEffect(() => {
    hideSplashScreen();
  }, []);

  useEffect(() => {
    enableScroll();
  }, [location.pathname]);

  return (
    <>
      <CustomBackdrop />
      <ExalusBackdropPopup />
      {/* <NativeAppDialog /> */}
    </>
  );
};
